import { connect } from "react-redux";

import ToolBar from "../Components/Converters/ToolBar.js";

const mapStateToProps = (state) => {
  return {
    locale: state.locale,
    enableCRUD: state.enableCRUD,
  };
};

const mapDispatchToProps = {};

/* Next line links component ToolBar, to:
-State variables defined on mapStateToProps
-functions defined on mapDispatchToProps */
export default connect(mapStateToProps, mapDispatchToProps)(ToolBar);
